module.exports = __webpack_public_path__ + "h5/img/选择.10ab517a.png";